import {
  HelperText,
  Radio,
  RadioGroup,
  RadioLabel,
} from "@hireart/component-library";
import { useField } from "formik";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";

export const FormRadioGroup = ({
  "aria-describedby": ariaDescribedBy = undefined,
  className = undefined,
  groupClassName = undefined,
  id = undefined,
  isDisabled = false,
  isOptional = false,
  label,
  name,
  onChange = () => {},
  options,
  radioClassName = undefined,
  radioLabelClassName = undefined,
}) => {
  const [field, meta] = useField({ name });
  const hasError = meta.touched && !isEmpty(meta.error);
  const groupId = id || name;
  const helperTextIds = [
    hasError ? `${groupId}-error` : undefined,
    ariaDescribedBy,
  ]
    .filter(Boolean)
    .join(" ");

  const handleChange = (e) => {
    field.onChange(e);
    onChange(e);
  };

  return (
    <div className={className}>
      <RadioGroup
        aria-describedby={helperTextIds}
        className={groupClassName}
        hasError={hasError}
        isOptional={isOptional}
        label={label}
      >
        {options.map((option) => (
          <RadioLabel className={radioLabelClassName} key={option.value}>
            <Radio
              {...field}
              inputClassName={radioClassName}
              isChecked={field.value === option.value}
              isDisabled={isDisabled}
              onChange={handleChange}
              value={option.value}
            />
            {option.text}
          </RadioLabel>
        ))}
      </RadioGroup>
      {hasError && (
        <HelperText hasError={hasError} id={`${groupId}-error`}>
          {meta.error}
        </HelperText>
      )}
    </div>
  );
};

FormRadioGroup.propTypes = {
  "aria-describedby": PropTypes.string,
  className: PropTypes.string,
  groupClassName: PropTypes.string,
  id: PropTypes.string,
  isDisabled: PropTypes.bool,
  isOptional: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  radioClassName: PropTypes.string,
  radioLabelClassName: PropTypes.string,
};
